<template>
  <v-app id="inspire">
    <!-- <v-navigation-drawer
      v-model="drawer"
      disable-resize-watcher
      :mini-variant="miniVariant"
      app
      fixed
    > -->
    <v-navigation-drawer
      id="drawer"
      app
      permanent
      :data-class="isHovered ? 'expand' : 'collapse'"
    >
      <v-list dense>
        <div v-for="(route, index) in routes" :key="index">
          <!-- route.children.length > 1 -->
          <v-divider v-if="route.divider"></v-divider>
          <div v-else>
            <v-list-group
              v-if="route.meta.expansion && route.children"
              :prepend-icon="route.meta.icon"
              no-action
            >
              <template v-slot:activator>
                <v-list-item-content class="color-white">
                  <v-list-item-title
                    class="color-white"
                    v-text="route.meta.title"
                  ></v-list-item-title>
                </v-list-item-content>
              </template>

              <div
                v-for="(child, index) in route.children"
                :key="index"
                class="item-padding"
              >
                <v-divider v-if="child.divider"></v-divider>
                <v-list-item
                  v-else
                  :to="`${route.path}/${child.path}`"
                  :data-class="isHovered ? 'expand' : 'collapse'"
                >
                  <v-list-item-content>
                    <v-list-item-title
                      class="color-white"
                      v-text="child.meta.title"
                    ></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </div>
            </v-list-group>
            <v-list-item v-else :to="route.path" class="color-white">
              <v-list-item-icon>
                <v-icon class="color-white">{{ route.meta.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="color-white">{{
                route.meta.title
              }}</v-list-item-title>
            </v-list-item>
          </div>
        </div>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app :src="banner">
      <!-- <v-app-bar-nav-icon
        class="color-white"
        @click.stop="actionMenu()"
      ></v-app-bar-nav-icon> -->
      <!-- <v-toolbar-title class="color-white"> -->

      <v-toolbar-title @click="goToLandingPage" class="cursor-pointer oblique">
        <div class="position-relative">
          <v-img :src="general.logo" max-width="100" max-height="40"></v-img>
          <div class="logo-label small" :style="{ color: general.label_color }">
            {{ general.label_text }}
          </div>
        </div>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <phone-button></phone-button>

      <v-menu :absolute="true" min-width="250px">
        <template v-slot:activator="{ on, attrs }">
          <div class="icon-help-nav" v-if="!isServiceUnhealthy">
            <v-icon v-bind="attrs" v-on="on" color="white">
              fa-regular fa-circle-question
            </v-icon>
          </div>
          <div v-bind="attrs" class="icon-exclamation-nav" v-on="on" v-else>
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  <v-btn text disabled>
                    <span class="fa-stack fa-1x">
                      <i
                        class="fa fa-exclamation fa-stack-2x fa-inverse"
                        style="color: black; padding-top: 3px; font-size: 1.5em"
                      ></i>
                      <i
                        class="fa fa-exclamation-triangle fa-stack-2x"
                        style="color: #FBB46C"
                      ></i>
                    </span>
                  </v-btn>
                </span>
              </template>
              <span>There are system errors. Please contact admin.</span>
            </v-tooltip>
          </div>
        </template>

        <v-list dense>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle
                class="font-size-header font-weight-unset text-center"
                >Information</v-list-item-subtitle
              >
            </v-list-item-content>
          </v-list-item>
          <v-divider class="m-t-5 m-b-5 m-r-30 m-l-30"></v-divider>

          <v-row>
            <v-col cols="1">
              <v-btn
                text
                v-if="
                  isServiceUnhealthy &&
                    (user.role.name === 'root' || user.role.name === 'admin')
                "
                disabled
              >
                <span class="fa-stack fa-1x">
                  <i
                    class="fa fa-exclamation fa-stack-2x fa-inverse"
                    style="color: black; padding-top: 3px; font-size: 1.5em"
                  ></i>
                  <i
                    class="fa fa-exclamation-triangle fa-stack-2x"
                    style="color: #FBB46C"
                  ></i>
                </span>
              </v-btn>
            </v-col>
            <v-col cols="10">
              <v-list-item
                @click="goToSystemStatus"
                class="ml-4"
                v-if="user.role.name === 'root' || user.role.name === 'admin'"
              >
                <v-list-item-content>
                  <v-list-item-subtitle
                    id="help-support-portal"
                    class="font-size-body"
                  >
                    System status</v-list-item-subtitle
                  >
                </v-list-item-content>
              </v-list-item>

              <v-list-item @click="goToChatbotix" class="ml-4">
                <v-list-item-content>
                  <v-list-item-subtitle
                    id="help-chatbotix-home"
                    class="font-size-body"
                  >
                    {{ 'product_name' | getVariable }} home
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-list-item @click="goToSupportPortal" class="ml-4">
                <v-list-item-content>
                  <v-list-item-subtitle
                    id="help-support-portal"
                    class="font-size-body "
                    >Support portal</v-list-item-subtitle
                  >
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>

          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle class="d-flex font-size-sub justify-end">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <div>
                      <span v-bind="attrs" v-on="on">
                        Version {{ version }}
                      </span>
                    </div>
                  </template>
                  <span>
                    <div
                      v-for="(value, index) in versionComponent"
                      :key="index"
                    >
                      {{ value }}
                    </div>
                  </span>
                </v-tooltip>
                <v-icon small class="m-l-5 m-b-5" @click="doCopy">
                  far fa-copy
                </v-icon>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-menu :absolute="true" v-model="profileMenu" min-width="300px">
        <template v-slot:activator="{ on, attrs }">
          <v-avatar size="36" v-bind="attrs" v-on="on">
            <img :src="userData.avatar" alt="avatar" />
          </v-avatar>
        </template>

        <v-list dense>
          <v-list-item>
            <v-list-item-content class="text-center">
              <v-list-item-title>
                <v-avatar size="128">
                  <img :src="userData.avatar" alt="avatar" />
                </v-avatar>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content class="text-center">
              <v-list-item-title
                class="font-size-header font-weight-unset m-b-10"
              >
                {{ userData.displayname }}
              </v-list-item-title>
              <v-list-item-subtitle class="font-size-body">
                {{ userData.email }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-divider class="m-t-5 m-b-5 m-r-30 m-l-30"></v-divider>

          <v-list-item @click="upDateProfileClick">
            <v-list-item-content>
              <v-list-item-subtitle
                id="user-information-update-profile"
                class="font-size-body"
                >Update profile</v-list-item-subtitle
              >
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            v-if="userData.auth_type === 'local'"
            @click="changePasswordClick"
          >
            <v-list-item-content>
              <v-list-item-subtitle
                id="user-information-change-password"
                class="font-size-body"
                >Change password</v-list-item-subtitle
              >
            </v-list-item-content>
          </v-list-item>

          <v-list-item @click="logoutClick">
            <v-list-item-content>
              <v-list-item-subtitle id="btn-logout" class="font-size-body"
                >Log out</v-list-item-subtitle
              >
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-dialog
      v-model="dialogLogout"
      @keydown.esc="cancelLogout"
      persistent
      scrollable
      content-class="small"
    >
      <v-card class="modal-dialog" height="200">
        <v-card-title
          class="
            dialog-title
            font-size-dialog-title font-weight-bold
            bg-primary
          "
          >Log out</v-card-title
        >
        <v-divider></v-divider>
        <v-card-text class="dialog-body font-size-body px-5 pt-3">
          <div>
            There are active chat sessions on Live chat page. It is recommended
            to manually end chats before logging out.
          </div>
          <div class="font-weight-bold pt-2">Force end chat and logout?</div>
        </v-card-text>
        <v-card-actions class="justify-end mx-3 mb-2">
          <v-btn small outlined class="btn-secondary" @click="cancelLogout()">
            Cancel
          </v-btn>
          <v-btn small outlined class="btn-primary" @click="doLogout()">
            Logout
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-if="dialogUpdateProfile"
      v-model="dialogUpdateProfile"
      @keydown.esc="updateProfileClose"
      persistent
      scrollable
      content-class="medium"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Update profile</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12" lg="12" class="text-center">
                <div
                  id="user-information-avatar"
                  class="position-relative"
                  @click="pickFile"
                >
                  <v-avatar
                    class="cursor-pointer"
                    size="128"
                    v-model="editUpdateProfile.imageName"
                  >
                    <img :src="editUpdateProfile.imageUrl" alt="avatar" />
                  </v-avatar>
                  <v-icon class="icon-upload-avatar cursor-pointer"
                    >camera_alt</v-icon
                  >
                  <input
                    type="file"
                    style="display: none"
                    ref="image"
                    accept="image/*"
                    @change="onFilePicked"
                  />
                </div>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="12">
                <span>{{ userData.email }}</span>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="12">
                <v-text-field
                  id="user-information-displayname"
                  v-model="editUpdateProfile.displayname"
                  label="Display name"
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <div id="error-user-information" class="red--text text-center">
          {{ editUpdateProfile.errorMessage }}
        </div>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            id="btn-close-user-information"
            class="btn-secondary"
            text
            @click="updateProfileClose"
            >Cancel</v-btn
          >
          <v-btn
            id="btn-ok-user-information-save"
            class="btn-primary"
            text
            @click="updateProfileSave"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <dialog-change-password
      v-if="dialogChangePassword"
      :dialogChangePassword="dialogChangePassword"
      @changePasswordClose="changePasswordClose"
      @changePasswordSave="changePasswordSave"
    />

    <v-snackbar
      v-model="snackbar.open"
      :color="snackbar.colorSnackbar"
      :timeout="3000"
      :top="true"
      :vertical="true"
    >
      {{ snackbar.textSnackbar }}

      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="snackbar.open = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <v-main
      class="padding-v-main"
      :data-class="isHovered ? 'expand' : 'collapse'"
    >
      <router-view
        :rulesEmail="rulesEmail"
        :rulesPassword="rulesPassword"
        :rulesDisplayname="rulesDisplayname"
        :rulesRole="rulesRole"
        :rulesCharcacters50="rulesCharcacters50"
        :rulesCharcacters100="rulesCharcacters100"
        :rulesCharcacters1000="rulesCharcacters1000"
      />

      <voice-client
        class="voice-client chat-action"
        v-show="isCallStart && uiMode == 'voice'"
      ></voice-client>

      <floating-active-call
        v-if="activeLiveCallSessionId != null && webRtcSession != 'Inactive'"
      ></floating-active-call>
    </v-main>

    <auto-logout />
  </v-app>
</template>

<script>
import _ from 'lodash'
import JsSIP from 'jssip'
import moment from 'moment'
import { mapGetters, mapActions } from 'vuex'
import { getRoutes } from '@/utils/permission'
import { bus } from '../main'
// import { constantRoutes } from '@/router'
import apiUser from '@/apis/user'
import apiAgent from '@/apis/agent'
import apiHealth from '@/apis/health'
import apiVersion from '@/apis/version'
import apiLivecall from '@/apis/livecall'
import VoiceClient from '@/components/agent/voice/voice_client_mini.vue'
import FloatingActiveCall from '@/components/agent/voice/floating_active_call.vue'
import Banner from '@/assets/polygon-banner.jpg'
import AutoLogout from '@/components/idle/auto-logout.vue'
import PhoneButton from '@/components/call/phone_button.vue'

import DialogChangePassword from '@/components/dialog_change_password'

export default {
  components: {
    AutoLogout,
    VoiceClient,
    PhoneButton,
    FloatingActiveCall,
    DialogChangePassword
  },
  props: {
    source: String
  },
  data() {
    return {
      agentSessions: [],
      dialogLogout: false,
      profileMenu: false,
      rulesEmail: {
        required: value => !!value || 'Required.',
        counter: value => value.length <= 20 || 'Max 20 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      },
      rulesPassword: {
        required: value => !!value || 'Required.'
      },
      rulesDisplayname: {
        required: value => !!value || 'Required.',
        min: v => v.length >= 1 || 'Min 1 characters',
        max: v => v.length < 51 || 'Max 50 charcacters'
      },
      rulesRole: {
        required: value => !!value || 'Required.',
        min: v => v.length >= 1 || 'Min 1 characters',
        max: v => v.length < 51 || 'Max 50 charcacters',
        name: value => {
          const pattern = /^[a-zA-Z0-9]+$/
          return pattern.test(value) || 'Invalid Name.'
        }
      },
      rulesCharcacters50: {
        required: value => !!value || 'Required.',
        min: v => v.length >= 1 || 'Min 1 charcacters',
        max: v => v.length < 51 || 'Max 50 charcacters'
      },
      rulesCharcacters100: {
        required: value => !!value || 'Required.',
        min: v => v.length >= 1 || 'Min 1 charcacters',
        max: v => v.length < 101 || 'Max 100 charcacters'
      },
      rulesCharcacters1000: {
        required: value => !!value || 'Required.',
        min: v => v.length >= 1 || 'Min 1 charcacters',
        max: v => v.length < 1001 || 'Max 1000 charcacters'
      },
      banner: Banner,
      logo: '',
      avatar: '',
      version: '',
      versionComponent: [],
      dialogUpdateProfile: false,
      editUpdateProfile: {
        imageName: '',
        imageUrl: '',
        imageFile: '',
        displayname: '',
        errorMessage: ''
      },
      userData: {},
      // drawer: null,
      // miniVariant: false,
      routes: [],
      notifications: [
        'Mike John Responded to your email',
        'You have 5 new tasks',
        "You're now friends with Andrew",
        'Another Notification',
        'Another one'
      ],
      snackbar: {
        open: false,
        colorSnackbar: '',
        textSnackbar: ''
      },
      isHovered: false,
      isHoveredTimeout: null,
      isCallStart: false,
      handler: null,
      allowMic: false,
      isServiceUnhealthy: false,
      reload: '',
      dialogChangePassword: false
    }
  },
  computed: {
    ...mapGetters('auth', ['user']),
    ...mapGetters('general', ['general']),
    ...mapGetters('agent', [
      'activeLiveCallSessionId',
      'uiMode',
      'isCurrentInCall',
      'webRtcSession'
    ])
    // bannerStyle() {
    //   return {
    //     backgroundImage: `${Banner} !important`
    //   }
    // }
  },
  watch: {
    dialogUpdateProfile(val) {
      val || this.updateProfileClose()
    },
    dialogLogout(val) {
      if (val) {
        this.profileMenu = false
      }
    }
  },
  created() {
    // this.checkRoleAgent()
    document.title = this.$t('page-title.title', {
      productName: this.$options.filters.getVariable('product_name')
    })
    this.userData = this.user
    this.setDefaultUpDateProfile()
    const pages = this.userData.role.pages
    this.routes = getRoutes(pages)
    // for (let i = 0; i < constantRoutes.length; i++) {
    //   if (!constantRoutes[i].hidden) this.routes.push(constantRoutes[i])
    // }
    this.initial()
    bus.$on('isCallStart', val => {
      this.changeCallStatus(val)
    })
    bus.$on('isCallEnded', val => {
      this.changeCallStatus(val)
    })
    this.$watch(
      function() {
        return this.isCurrentInCall
      },
      function(newVal, oldVal) {
        //do we need to add?
        if (newVal === true) {
          this.handler = function(e) {
            // Cancel the event

            e.preventDefault()

            // Chrome requires returnValue to be set
            e.returnValue = ''
          }

          window.addEventListener('beforeunload', this.handler)
        } else if (newVal === false) {
          window.removeEventListener('beforeunload', this.handler)

          this.handler = null
        }
      }
    )
    this.getHealth()
    this.setIntervalRun()
  },
  beforeDestroy() {
    bus.$off('isCallStart')
    bus.$off('isCallEnded')
    clearInterval(this.reload)
  },
  mounted() {
    const drawer = document.getElementById('drawer')
    drawer.addEventListener('mouseover', () => {
      if (this.isHoveredTimeout) clearTimeout(this.isHoveredTimeout)
      this.isHoveredTimeout = setTimeout(() => {
        this.isHovered = true
        this.isHoveredTimeout = null
      }, 400)
    })
    drawer.addEventListener('mouseleave', () => {
      if (this.isHoveredTimeout) clearTimeout(this.isHoveredTimeout)
      this.isHoveredTimeout = setTimeout(() => {
        this.isHovered = false
        this.isHoveredTimeout = null
      }, 10)
    })
  },
  methods: {
    ...mapActions('general', ['setGeneral']),
    ...mapActions('auth', ['logout']),
    ...mapActions('auth', ['updateProfile']),
    ...mapActions('agent', [
      'removeAgentSession',
      'clearActiveSession',
      'removeLiveCallAgentSession',
      'clearLiveCallActiveSession',
      'setIsCurrentInCall',
      'setTimerBegan',
      'setWebRtcSession'
    ]),
    // actionMenu() {
    //   // console.log(this.isMobile())
    //   if (this.isMobile()) {
    //     this.drawer = !this.drawer
    //     this.miniVariant = false
    //   } else {
    //     this.drawer = true
    //     this.miniVariant = !this.miniVariant
    //   }
    // },
    // isMobile() {
    //   if (screen.width >= 1264) {
    //     return false
    //   } else {
    //     return true
    //   }
    // },

    async closeClicked() {
      await this.endVoiceSession()
      bus.$emit('dropCallByDoLogout', 'hanged up')
    },

    removeHandler() {
      if (this.handler) window.removeEventListener('beforeunload', this.handler)
      return true
    },
    changeCallStatus(val) {
      this.isCallStart = val
    },
    async initial() {
      await this.setGeneralStore()
      await this.getVersion()
    },
    async setGeneralStore() {
      await this.setGeneral()
        .then(() => {})
        .catch(error => {})
    },
    async getVersion() {
      try {
        const getVersion = await apiVersion.getVersion()
        if (getVersion && getVersion.version) {
          this.version = getVersion.version.version
          const comp = Object.keys(getVersion.version)
            .sort()
            .reduce((r, k) => ((r[k] = getVersion.version[k]), r), {})
          for (const key in comp) {
            if (!['key', 'version'].includes(key) && comp[key])
              this.versionComponent.push(`${this.capitalize(key)} ${comp[key]}`)
          }
        }
      } catch {}
    },
    async cancelLogout() {
      this.dialogLogout = false
    },
    goToLandingPage() {
      window.location = '/realtime' // '/conversations'
    },
    goToChatbotix() {
      window.open(this.$options.filters.getVariable('product_home'))
    },
    goToSupportPortal() {
      window.open(this.$options.filters.getVariable('support_portal'))
    },
    goToSystemStatus() {
      if (this.user.role.pages.includes('Information - System status')) {
        window.open('/status')
      }
    },
    upDateProfileClick() {
      this.dialogUpdateProfile = true
    },
    updateProfileClose() {
      this.dialogUpdateProfile = false
      this.setDefaultUpDateProfile()
    },
    async updateProfileSave() {
      try {
        if (!this.editUpdateProfile.displayname) {
          this.editUpdateProfile.errorMessage = 'Display name is required'
          return false
        } else if (
          this.editUpdateProfile.displayname.length < 1 ||
          this.editUpdateProfile.displayname.length > 50
        ) {
          this.editUpdateProfile.errorMessage =
            'Display name must be 1-50 characters'
          return false
        }
        const obj = {
          avatar: this.editUpdateProfile.imageUrl,
          displayname: this.editUpdateProfile.displayname
        }
        const updateProfile = await this.updateProfile({
          id: this.userData._id,
          obj
        })
        this.snackbar.colorSnackbar = 'success'
        this.snackbar.textSnackbar = 'Changes saved'
        this.snackbar.open = true
        this.updateProfileClose()
      } catch (error) {
        this.editUpdateProfile.errorMessage = error.message
      }
    },
    pickFile() {
      this.$refs.image.click()
    },
    onFilePicked(e) {
      const files = e.target.files
      if (files[0] !== undefined) {
        this.editUpdateProfile.imageName = files[0].name
        if (this.editUpdateProfile.imageName.lastIndexOf('.') <= 0) {
          return
        } else if (
          parseFloat((files[0].size / (1024 * 1024)).toFixed(2)) > 10
        ) {
          this.editUpdateProfile.errorMessage =
            'The image is too large. Please select file no larger than 10 MB.'
          return
        } else if (
          this.editUpdateProfile.errorMessage ===
          'The image is too large. Please select file no larger than 10 MB.'
        ) {
          this.editUpdateProfile.errorMessage = ''
        }
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.editUpdateProfile.imageUrl = fr.result
          this.editUpdateProfile.imageFile = files[0] // this is an image file that can be sent to server...
        })
      } else {
        this.editUpdateProfile.imageName = ''
        this.editUpdateProfile.imageUrl = this.userData.avatar
        this.editUpdateProfile.imageFile = ''
      }
    },
    setDefaultUpDateProfile() {
      const size = Object.keys(this.$refs).length
      if (size !== 0) {
        this.$refs.image.value = ''
      }
      this.editUpdateProfile.imageName = ''
      this.editUpdateProfile.imageUrl = this.userData.avatar
      this.editUpdateProfile.imageFile = ''
      this.editUpdateProfile.displayname = this.userData.displayname
      this.editUpdateProfile.errorMessage = ''
    },
    changePasswordClick() {
      this.dialogChangePassword = true
    },
    changePasswordClose() {
      this.dialogChangePassword = false
    },
    async changePasswordSave() {
      this.snackbar.colorSnackbar = 'success'
      this.snackbar.textSnackbar = 'Changes saved'
      this.snackbar.open = true

      this.changePasswordClose()
    },
    async logoutClick() {
      try {
        const sessions = await apiAgent.getSessionsList()
        if (sessions?.data?.length) {
          this.dialogLogout = true
          this.agentSessions = sessions.data
        } else {
          this.doLogout()
        }
      } catch (error) {
        this.snackbar.colorSnackbar = 'error'
        this.snackbar.textSnackbar = `Logout failed, ${error.message}`
        this.snackbar.open = true
      }
    },
    async endSession(agentSessionId, sessionId) {
      const body = {
        agent_session_id: agentSessionId,
        session_id: sessionId
      }
      // update [AgentSession].status = close
      await apiAgent.closeAgentSession(body)
      this.removeAgentSession(sessionId)
      this.clearActiveSession()
      // call social-plugin to end session from agent
      await apiAgent.endSession(body)
    },

    async endVoiceSession() {
      try {
        const sessionId = this.activeLiveCallSessionId
        //add use update check call 05-05-2022
        const checkcall = {
          status: 'ended by agent'
        }
        await apiLivecall.updateCheckCall(sessionId, checkcall)

        if (this.isCurrentInCall) {
          const livecalllog = {
            status: 'hanged up',
            destination: this.user.displayname,
            wrap_up: 'Agent logged out'
          }

          await apiLivecall.updateSystemMessage(
            this.activeLiveCallSessionId,
            livecalllog
          )
        }

        const body = {
          agent_session_id: this.activeLiveCallSessionId,
          session_id: this.activeLiveCallSessionId
        }
        await apiLivecall.closeAgentVoiceSession(body)
        this.removeLiveCallAgentSession(this.activeLiveCallSessionId)
        this.clearLiveCallActiveSession()
        // call social-plugin to end session from agent
        await apiAgent.endSession(body)
        this.setIsCurrentInCall(false)
        this.setTimerBegan(null)

        // TODO: have to verify respond is it success? before do next step
      } catch (error) {
        // TODO: Pock: have to do somthing
      }
    },

    async doLogout() {
      try {
        if (this.agentSessions.length > 0) {
          for (let i = 0; i < this.agentSessions.length; i++) {
            const session = this.agentSessions[i]
            await this.endSession(session.agent_session._id, session.session_id)
          }
        }

        if (this.activeLiveCallSessionId) {
          await this.endVoiceSession()
          bus.$emit('dropCallByDoLogout', 'hanged up')
        }

        //
        this.logout()
          .then(() => {
            this.$router.replace({
              // path: '/login',
              name: 'Login',
              params: {
                email: this.userData.email,
                auth_type: this.userData.auth_type
              }
            })
          })
          .catch(error => {
            this.error = error
          })
      } catch (error) {
        this.snackbar.colorSnackbar = 'error'
        this.snackbar.textSnackbar = `End session failed, ${error.message}`
        this.snackbar.open = true
      }
    },
    capitalize(text) {
      const string = text.replace(/-/g, ' ')
      if (['ari', 'ffm', 'nlu'].includes(string)) return string.toUpperCase()
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    doCopy() {
      let chatbotix = [`Version ${this.version}`]
      chatbotix = [...chatbotix, ...this.versionComponent]
      const text = chatbotix.join('\r\n')
      this.$copyText(text).then(() => {
        this.snackbar.colorSnackbar = 'success'
        this.snackbar.textSnackbar = 'Version is copied'
        this.snackbar.open = true
      })
    },
    async getHealth() {
      try {
        const data = await apiHealth.getHealth()
        if (data.data.status !== 'normal') {
          this.isServiceUnhealthy = true
        } else {
          this.isServiceUnhealthy = false
        }
      } catch (error) {
        this.isServiceUnhealthy = true
      }
    },

    async setIntervalRun() {
      this.reload = setInterval(() => {
        this.getHealth()
      }, 30000)
    }
    // checkRoleAgent() {
    //   // check Agent have role = Live agent Allow Mic
    //   for (var i = 0; i < this.user.role.pages.length; i++) {
    //     if (this.user.role.pages[i] == 'Live agent') {
    //       this.allowMic = true
    //     }
    //   }
    // }
  }
}
</script>
<style lang="scss" scoped>
.modal-dialog .dialog-title {
  padding: 6px 20px 6px 20px !important;
}
.modal-dialog .dialog-body {
  overflow: hidden !important;
}
.color-white {
  color: white !important;
}
.padding-v-main {
  padding-top: 50px !important;
}
.icon-upload-avatar {
  position: absolute !important;
  bottom: -5px;
  right: 80px;
}
.icon-help-nav {
  margin-right: 10px;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  text-align: center;
  line-height: 10px;
  vertical-align: middle;
  .v-icon {
    font-size: 25px;
    color: $text-color;
  }
}

.icon-exclamation-nav {
  margin-right: 30px;
  margin-bottom: 8px;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  text-align: center;
  line-height: 10px;
  vertical-align: middle;
  .v-icon {
    font-size: 25px;
    color: #fbb46c;
  }
}

::v-deep .v-toolbar__content {
  padding: 0 15px 0 0;
}
.oblique {
  width: 180px;
  height: 100%;
  background: linear-gradient(
    -60deg,
    transparent 0%,
    transparent 15%,
    white 15%
  );
  display: flex;
  align-items: center;
  justify-content: center;
  .v-image {
    margin-left: -20px;
  }
}
.voice-client {
  position: fixed;
  width: 100%;
  bottom: 0;
  margin: auto;
  z-index: 99;
}
// .numeric-keypad {
//   display: grid;
//   align-items: center;
//   justify-content: center;
//   grid-template-columns: 40px 40px 40px;
//   grid-gap: 2px;
// }
// .numeric-keypad-btn {
//   width: 40px;
//   height: 40px;
// }
.btn-phone {
  box-shadow: none;
  border-radius: 50%;
} //
</style>
